import { Box, Typography, Button } from '@mui/material';
import EmptyBox from '@mui/icons-material/Inventory2Outlined';
import PropTypes from 'prop-types';

export default function EmptyState({ onCreate }) {
    return (
        <Box
            sx={{
                py: 6,
                textAlign: 'center',
                opacity: 0.8
            }}
        >
            <EmptyBox sx={{ fontSize: 80, mb: 2 }} />

            <Typography variant="h6" gutterBottom>
                You haven't added any products yet.
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={3}>
                Add your first product to start selling to customers.
            </Typography>

            <Button variant="contained" onClick={onCreate}>
                Add New Product
            </Button>
        </Box>
    );
}

EmptyState.propTypes = {
    onCreate: PropTypes.func.isRequired
};
